export default __webpack_public_path__ + "static/media/ag-title-cn.12d167fb.webp";